// Meta descriptions for different pages
const metaDescriptions = {
  // Main pages
  home: "Ace Keystone Consultants deliver cutting-edge innovative solutions in AI, geospatial intelligence, biomedical engineering, mobile app development, and smart infrastructure. Transforming ideas into reality since 2022.",
  
  about: "Learn about AK Consultants - a forward-thinking company functioning since 2022, dedicated to delivering innovative, scalable solutions in AI, smart infrastructure, and business strategy.",
  
  portfolio: "Explore our portfolio showcasing innovative projects and achievements at Ace Keystone Consultants. See our expertise in GIS, AI/ML, and technology solutions.",
  
  services: "Explore AK Consultants' comprehensive services including AI & Machine Learning, GIS & Geospatial Intelligence, Biomedical Engineering, Mobile App Development, and Full Stack Development solutions.",
  
  ourtech: "Discover the cutting-edge technologies powering AK Consultants' solutions - from AI frameworks and cloud platforms to GIS tools and mobile development technologies.",
  
  teams: "Meet the expert team at AK Consultants - passionate professionals specializing in AI, geospatial intelligence, biomedical engineering, and full-stack development.",
  
  contact: "Get in touch with AK Consultants for innovative technology solutions. Contact our expert team for AI, GIS, biomedical engineering, and software development services.",
  
  careers: "Join AK Consultants' growing team! Explore exciting career opportunities in AI, software development, electronics engineering, biomedical engineering, and more in Coimbatore.",
  
  blogs: "Stay updated with the latest insights from AK Consultants' experts. Read our blog for trends in AI, machine learning, GIS, mobile development, and biomedical engineering.",
  
  'services/geo-spatial': "Professional GIS and geospatial intelligence services by AK Consultants. Advanced mapping, spatial analysis, and location-based solutions for businesses and organizations.",
  
  'careers/student-intern': "Digital Internship opportunities at AK Consultants. Join our team to work on cutting-edge digital platforms and scalable systems across various departments.",
  
  'careers/electronics-engineer': "Electronic Design Engineer position at AK Consultants, Coimbatore. Join our hardware team for end-to-end development of electronic systems with 2+ years experience.",
  
  'careers/project-admin': "Project Administrator role at AK Consultants. Assist project managers with planning and maintaining timelines in our growing software team.",
  
  'careers/innovation-engineering-graduate-pathway': "Innovation & Engineering Graduate Pathway at AK Consultants. Exposure to emerging technologies and consulting practices for graduates in Coimbatore.",
};

// Function to get meta description by route
const getMetaDescription = (route) => {
  // Remove leading slash and convert to lowercase
  const cleanRoute = route.replace(/^\//, '').toLowerCase();
  
  // Handle blog posts dynamically
  if (cleanRoute.startsWith('blogs/') && cleanRoute !== 'blogs') {
    const blogSlug = cleanRoute.replace('blogs/', '');
    return `Read "${blogSlug.replace(/-/g, ' ')}" - Expert insights from AK Consultants on AI, technology, and innovation. Stay updated with the latest industry trends and technical expertise.`;
  }
  
  // Return specific description or default
  return metaDescriptions[cleanRoute] || metaDescriptions.home;
};

// Function to get page title by route
const getPageTitle = (route, customTitle = null) => {
  if (customTitle) return `${customTitle} | AK Consultants`;
  
  const cleanRoute = route.replace(/^\//, '').toLowerCase();
  
  const titles = {
    '': 'AK Consultants - Innovative Technology Solutions',
    'about': 'About Us | AK Consultants',
    'portfolio': 'Portfolio | AK Consultants',
    'services': 'Our Services | AK Consultants',
    'ourtech': 'Our Technology Stack | AK Consultants',
    'teams': 'Our Team | AK Consultants',
    'contact': 'Contact Us | AK Consultants',
    'careers': 'Careers | AK Consultants',
    'blogs': 'Blog | AK Consultants',
    'services/geo-spatial': 'GIS & Geospatial Services | AK Consultants',
  };
  
  // Handle blog posts
  if (cleanRoute.startsWith('blogs/') && cleanRoute !== 'blogs') {
    const blogSlug = cleanRoute.replace('blogs/', '');
    const blogTitle = blogSlug.split('-').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
    return `${blogTitle} | AK Consultants Blog`;
  }
  
  // Handle career posts
  if (cleanRoute.startsWith('careers/') && cleanRoute !== 'careers') {
    const jobSlug = cleanRoute.replace('careers/', '');
    const jobTitle = jobSlug.split('-').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
    return `${jobTitle} | Careers at AK Consultants`;
  }
  
  return titles[cleanRoute] || 'AK Consultants';
};

// Export for both CommonJS (Node.js build scripts) and ES6 (React components)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { metaDescriptions, getMetaDescription, getPageTitle };
}

export { metaDescriptions, getMetaDescription, getPageTitle };